
class ProfileIconController {
    constructor() {
        'ngInject';
    }

    getInitials() {
        let name = ''

        if (this.patient.patient.firstName) {
            name += this.patient.patient.firstName.charAt(0).toUpperCase()
        }

        if (this.patient.patient.lastName) {
            name += this.patient.patient.lastName.charAt(0).toUpperCase()
        }

        return name
    }
}

export const ProfileIconComponent = {
    name: 'profileIcon',
    component: {
        template: `
        <img ng-if="$ctrl.patient.patient.photo != ''" class="profile-icon" ng-src="/mobile/webClient/image/{{$ctrl.patient.patient.photo}}"></img>
        <div ng-if="$ctrl.patient.patient.photo == ''" class="initials">{{$ctrl.getInitials()}}</div>
        `,
        controller: ProfileIconController,
        bindings: {
            patient: '<'
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/profileIcon.component.js